import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-[#0f0f0f] relative border-y border-studio-gold/10 overflow-hidden" data-id="element-10">
      {/* Subtle background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-studio-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-11" />

      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-16" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full md:w-1/2 flex justify-center" data-id="element-13">
          <div className="relative" data-id="element-14">
            <div className="absolute inset-0 border border-studio-gold/30 translate-x-4 translate-y-4" data-id="element-15"></div>
            <img src="https://cdn.magicpatterns.com/uploads/k3vPB6bqF4Bu3VhmuM7VGb/logo_nikki.jpg" alt="Bella Beauty Couture Experience" className="relative z-10 w-full max-w-md shadow-2xl" data-id="element-16" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full md:w-1/2 text-center md:text-left rtl:md:text-right" data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-playfair text-white mb-6" data-id="element-18">
            {t('about.title')}
          </h2>
          <h3 className="text-xl text-studio-gold font-playfair italic mb-8" data-id="element-19">
            {t('about.subtitle')}
          </h3>

          <p className="text-gray-300 font-inter font-light leading-relaxed mb-6 text-lg" data-id="element-20">
            {t('about.p1')}
          </p>
          <p className="text-gray-400 font-inter font-light leading-relaxed" data-id="element-21">
            {t('about.p2')}
          </p>
        </motion.div>
      </div>
    </section>;
}